import {GridColDef, GridRenderHeaderFilterProps} from '@mui/x-data-grid-pro';
import AurDataGridPro from '../../../common/aur-data-grid-pro/AurDataGridPro';
import {t} from 'i18next';

import FilterTextField from '../../../common/aur-data-grid-pro/FilterTextField';
import {Typography} from '@mui/material';

const DataGridPro = () => {
  return (
    <div>
      <Typography fontSize={24}>Data Grid Pro</Typography>
      <br></br>
      <AurDataGridPro
        className="project-list-grid"
        rows={rows}
        columns={columns}
        pageSizeOptions={[10, 15, 20]}
        entityType={t('common.projectsPagination')}
        rowLimitForPaginationHide={10}
        showPagination={true}
        disableColumnResize={true}
        defaultSortColumnName="projectName"
        primaryKey="id"
        checkBoxVisible={false}
        rowSelection={false}
        headerFilters
        disableColumnFilter
        defaultItemsPerPage={10}
      />
    </div>
  );
};
const columns: GridColDef[] = [
  {
    field: 'id',
    headerName: 'ID',
    width: 90,
    sortable: true, // Allows sorting on this column
    filterable: true, // No filter input for ID column
    renderHeaderFilter: (params: GridRenderHeaderFilterProps) => {
      return (
        <FilterTextField
          gridRenderHeaderFilterProps={params}
          label="Search ID"
        />
      );
    },
  },
  {
    field: 'projectName',
    headerName: 'Project Name',
    width: 150,
    sortable: true, // Enables sorting by project name
    filterable: true, // Allows text-based filtering on this column
    renderHeaderFilter: (params: GridRenderHeaderFilterProps) => {
      return (
        <FilterTextField
          gridRenderHeaderFilterProps={params}
          label="Search project Name"
        />
      );
    },
  },
  {
    field: 'description',
    headerName: 'Description',
    width: 200,
    sortable: true, // Enables sorting by description
    filterable: true, // Allows text-based filtering on this column
    renderHeaderFilter: (params: GridRenderHeaderFilterProps) => {
      return (
        <FilterTextField
          gridRenderHeaderFilterProps={params}
          label="Search description"
        />
      );
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 150,
    sortable: true, // Enables sorting by status
    filterable: true,
    renderHeaderFilter: (params: GridRenderHeaderFilterProps) => {
      return (
        <FilterTextField
          gridRenderHeaderFilterProps={params}
          label="Search status"
        />
      );
    },
  },
];
const rows = [
  {
    id: 1,
    projectName: 'Project Alpha',
    description: 'Initial project setup',
    status: 'Active',
  },
  {
    id: 2,
    projectName: 'Project Beta',
    description: 'Beta testing phase',
    status: 'Inactive',
  },
  {
    id: 3,
    projectName: 'Project Gamma',
    description: 'Research and development',
    status: 'Pending',
  },
  {
    id: 4,
    projectName: 'Project Delta',
    description: 'Deployment preparation',
    status: 'Completed',
  },
  {
    id: 5,
    projectName: 'Project Epsilon',
    description: 'Marketing and outreach',
    status: 'Active',
  },
  {
    id: 6,
    projectName: 'Project Zeta',
    description: 'Data collection',
    status: 'Active',
  },
  {
    id: 7,
    projectName: 'Project Eta',
    description: 'UI/UX Design phase',
    status: 'Inactive',
  },
  {
    id: 8,
    projectName: 'Project Theta',
    description: 'Initial concept development',
    status: 'Completed',
  },
  {
    id: 9,
    projectName: 'Project Iota',
    description: 'User feedback collection',
    status: 'Pending',
  },
  {
    id: 10,
    projectName: 'Project Kappa',
    description: 'Performance improvements',
    status: 'Active',
  },
  {
    id: 11,
    projectName: 'Project Lambda',
    description: 'Backend API development',
    status: 'Completed',
  },
  {
    id: 12,
    projectName: 'Project Mu',
    description: 'Database setup and migration',
    status: 'Inactive',
  },
  {
    id: 13,
    projectName: 'Project Nu',
    description: 'Frontend development',
    status: 'Pending',
  },
  {
    id: 14,
    projectName: 'Project Xi',
    description: 'Documentation writing',
    status: 'Completed',
  },
  {
    id: 15,
    projectName: 'Project Omicron',
    description: 'Testing and QA',
    status: 'Active',
  },
  {
    id: 16,
    projectName: 'Project Pi',
    description: 'Customer support integration',
    status: 'Pending',
  },
  {
    id: 17,
    projectName: 'Project Rho',
    description: 'Security audit',
    status: 'Inactive',
  },
  {
    id: 18,
    projectName: 'Project Sigma',
    description: 'Data visualization development',
    status: 'Active',
  },
  {
    id: 19,
    projectName: 'Project Tau',
    description: 'System architecture review',
    status: 'Completed',
  },
  {
    id: 20,
    projectName: 'Project Upsilon',
    description: 'Mobile app optimization',
    status: 'Active',
  },
];

export default DataGridPro;
